<template>
  <Navbar :prop-active-menu="constants.ROUTING.SIMULATION"
          :prop-show-sections="true"
          :prop-show-feedback="true"
          :prop-feedback-from-section="constants.FEEDBACK.SIMULATION"
          :prop-open-feedback="feedback.show"
          :prop-close-feedback="feedback.close"
          @on-feedback-close="onFeedbackClose"
  />

  <!-- Map -->
  <MapView
      :prop-feedback-status="feedback.show"
      :prop-modal-about-close="modals.about.trigger"
      :prop-modal-initial-conditions-close="modals.initialConditions.trigger"
      :prop-modal-anthropic-works-close="modals.anthropicWorks.trigger"
      :prop-modal-plot-close="modals.plot.trigger"
      @on-modal-open-close="modalOnOpenClose"
      @on-open-feedback-click="onOpenFeedbackClick"/>

  <!-- Cookies window -->
  <PrivacyCookies/>

  <!-- Pixel -->
  <Pixel :prop-source="constants.ROUTING.SIMULATION" v-if="flagUsePixel()===true"/>
</template>
<script>
import LoginStorage from '@/libs/Login';
import constants from "@/libs/Constants";
import Navbar from '@/components/Navbar.vue';
import Pixel from "@/components/Pixel.vue";
import plausible from "@/libs/PlausibleTracker";
import MapView from '@/views/Simulation/MapView.vue';
import ModalWindow from '@/components/ModalWindow.vue';
import PrivacyCookies from "@/components/PrivacyCookies.vue";
import {flagRegisteredEmail, flagUsePixel} from "@/libs/Helpers";

export default {
  name: 'DssMapView',
  components: {
    Pixel,
    PrivacyCookies,
    Navbar,
    ModalWindow,
    MapView
  },
  data() {
    return {
      constants: constants,
      feedback: {
        show: false,
        close: false
      },
      modals: {
        about: {
          status: false,
          trigger: false
        },
        initialConditions: {
          status: false,
          trigger: false
        },
        anthropicWorks: {
          status: false,
          trigger: false
        },
        plot: {
          status: false,
          trigger: false
        },
      }
    };
  },
  methods: {
    flagUsePixel,
    modalOnOpenClose(modalType, status) {
      console.log('Setting modal', modalType, 'to', status);
      this.modals[modalType].status = status;
    },
    onOpenFeedbackClick() {
      this.feedback.show = true;
    },
    onFeedbackClose() {
      this.feedback.show = false;
    }
  },
  beforeMount() {
    /**
     * Verify that user has registered the e-mail, otherwise redirect to landing page
     */
    if (flagRegisteredEmail() === true && LoginStorage.emailRegistered === null) {
      this.$router.push({name: constants.ROUTING.LANDING, replace: true});
      return false;
    }
  },
  beforeRouteLeave(to, from, next) {
    let modalSectionClosed = false;

    if (this.feedback.show) {
      this.modals.initialConditions.trigger = !this.modals.initialConditions.trigger;
      this.onFeedbackClose();
    }

    //Force to close feedback if opened from navbar
    this.feedback.close = !this.feedback.close;

    Object.keys(this.modals).forEach(section => {
      if (this.modals[section].status === true) {
        this.modals[section].trigger = !this.modals[section].trigger;
        modalSectionClosed = true;
      }
    });

    if (modalSectionClosed === false)
      next(true);
    else {
      this.$nextTick(() => {
        next(true);
      })
    }
  },
  mounted() {
    plausible.trackPageview();
  }
};

</script>
